module.exports = new __parcel__URL__("epa-agriculture--cover.1b4dd75a.jpg").toString();